import { TOGGLE_HEADER, TOGGLE_RIGHT_PANE, TOGGLE_LEFT_NAV, ESCAPE } from "../constants/ActionTypes";
import { WINDOW_RESIZE } from "../constants/ActionTypes";
import { DEMO_COMPLETE } from "../constants/ActionTypes";


export function toggleHeader() {
	return {
		type: TOGGLE_HEADER
	};
}

export function handleDemoComplete() {
	d3.select(".removemeafterload").remove();
	// 
	return {
		type: DEMO_COMPLETE
	};
}

export function toggleRightPane() {
	return (dispatch, getState) => {
		dispatch(toggleRightPaneSync());
		setTimeout(() => {
			dispatch(windowResize());
		}, 20);
	};
}

export function toggleRightPaneSync() {
	return {
		type: TOGGLE_RIGHT_PANE
	};
}

export function toggleLeftNav() {
	return {
		type: TOGGLE_LEFT_NAV
	};
}

export function escape() {
	return {
		type: ESCAPE
	};
}

export function windowResize() {
	return {
		type: WINDOW_RESIZE,
	};
}

/*
export function toggleLeftNav() {
	return (dispatch, getState) => {
		const { shouldShow } = getState();

		if (shouldShow % 2 === 0) {
			return;
		}

		dispatch(increment());
	};
}

export function incrementAsync() {
	return dispatch => {
		setTimeout(() => {
			dispatch(increment());
		}, 1000);
	};
}*/



/** WEBPACK FOOTER **
 ** ./src/scripts/actions/PageActions.js
 **/